"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isInited(payload) {
    var testConfig = payload;
    return (typeof testConfig.apiKeys === "object" &&
        typeof testConfig.url === "string" &&
        (testConfig.cookies === "auto" || testConfig.cookies === "manual"));
}
exports.isInited = isInited;
